import { render, staticRenderFns } from "./BookingSlotStats.vue?vue&type=template&id=3e27c52e&"
import script from "./BookingSlotStats.vue?vue&type=script&lang=js&"
export * from "./BookingSlotStats.vue?vue&type=script&lang=js&"
import style0 from "./BookingSlotStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports